import { render, staticRenderFns } from "./light.vue?vue&type=template&id=8a866ce8&scoped=true&"
import script from "./light.vue?vue&type=script&lang=js&"
export * from "./light.vue?vue&type=script&lang=js&"
import style0 from "./light.vue?vue&type=style&index=0&id=8a866ce8&prod&lang=css&"
import style1 from "./light.vue?vue&type=style&index=1&id=8a866ce8&prod&lang=less&scoped=true&"
import style2 from "./light.vue?vue&type=style&index=2&id=8a866ce8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a866ce8",
  null
  
)

export default component.exports